import {
  HomefieldIconGgLogoHover,
  HomefieldIconDsgLogo2024,
  HomefieldIconDsgLogo,
  HomefieldIconPlf,
  HomefieldIconPlLogoHeader,
  HomefieldIconPlMobileHeaderLogo,
} from '@dsg-tech/homefield-react-icons';

import { checkStores } from 'utility/utility';

type Props = {
  storeIdentifierName: string;
  newDsgLogo?: boolean;
  className?: string;
};

const HeaderLogo = ({ storeIdentifierName, className = '', newDsgLogo = false }: Props) => {
  const getBrandLogo = () => {
    switch (storeIdentifierName) {
      case 'pl':
        return (
          <>
            <span className="header2-pl-full-logo hmf-display-none hmf-display-lg-block">
              <HomefieldIconPlf
                className="hmf-pr-xxs hmf-pr-m-xs header2-pl-icon"
                width={22}
                height={22}
                color="white"
              />
              <HomefieldIconPlLogoHeader className="header2-pl-logo" width={28} height={28} />
            </span>
            <HomefieldIconPlMobileHeaderLogo className="header2-pl-mobile-logo hmf-display-block hmf-display-lg-none" />
          </>
        );
      case 'gg':
        return (
          <div className="header-gg-logo">
            <HomefieldIconGgLogoHover width="105px" height="49px" />
          </div>
        );
      default:
        return newDsgLogo ? (
          <HomefieldIconDsgLogo2024 className="dsg-logo" />
        ) : (
          <HomefieldIconDsgLogo />
        );
    }
  };

  return (
    <div
      className={`header_logo_container hmf-display-flex hmf-justify-content-flex-start hmf-flex-md-grow hmf-flex-lg-grow-none ${
        className || 'hmf-pb-0'
      }`}>
      <a
        id="header-logo"
        className="Header_Logo"
        href={checkStores('/')}
        tabIndex={0}
        aria-label="Navigate to homepage">
        {getBrandLogo()}
      </a>
    </div>
  );
};

export default HeaderLogo;
